import { SortParams } from '@epicuro-next/data/baskets';
import {
  BasketGroupSortType,
  SortDirection,
} from 'graphql-api/baskets-api-interfaces';

export function getNextSortingState(
  currentState: SortParams,
  sorting: BasketGroupSortType,
  hasThirdState: boolean,
  defaultParams: SortParams,
): SortParams {
  if (currentState.type === sorting) {
    if (currentState.direction === SortDirection.Asc) {
      return {
        type: sorting,
        direction: SortDirection.Desc,
      };
    } else if (currentState.direction === SortDirection.Desc && hasThirdState) {
      return defaultParams;
    }
  }

  return {
    type: sorting,
    direction: SortDirection.Asc,
  };
}
